import React from 'react';
import Footer from './Footer';
import Header from './Header';
import FeatherIcon from 'feather-icons-react';
import ScrollUpButton from 'react-scroll-up-button';

const CustomDot = () => {
    return (
        <i>
            <FeatherIcon
                icon="arrow-up"
                className="icons"
            />
        </i>
    );
};

const Layout = ({ children }) => {
    return (
        <React.Fragment>
            <Header />
            {children}
            <Footer />

            <ScrollUpButton
                ContainerClassName="classForContainer"
                style={{ height: 36, width: 36 }}
                TransitionClassName="classForTransition"
            >
                <CustomDot />
            </ScrollUpButton>
        </React.Fragment>
    );
};

export default Layout;
